import classNames from 'classnames';
import NextLink from 'next/link';
import { FC } from 'react';
import { LinkProps } from 'type';

type LinkType = {
  link: LinkProps;
  className?: string;
};

const Link: FC<LinkType> = ({ link, className }) => {
  const classes = classNames('text-link', className);

  return (
    <NextLink href={link.url} target={link.target} className={classes}>
      {link.text}
    </NextLink>
  );
};

export default Link;
